import React, { Component, useRef } from "react";
import { EventBus, EventBusEvents } from "@/store/event-bus.ts";
import Fileinput from "@/components/ui/Fileinput";
import { toast } from "react-toastify";
import { constants } from "@/constants.js";
import { urlChatID } from "@/utils/url.js";

import ListFiles from "@/pages/chatbot/sources/ListFiles.jsx";
import LoadingSpinner from "@/components/partials/LoadingSpinner.jsx";
import { queryKeyChatbotSummary } from "@/pages/chatbot/sources/ChatBotSources.tsx";
import { useQueryClient, useQuery, useMutation } from "react-query";
import {useTranslation} from "react-i18next";

const ChatBotSourcesFiles = () => {
  const queryClient = useQueryClient();
  const {t} = useTranslation();

  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [uploading, setUploading] = React.useState(false);
  const [fileInputID, setFileInputID] = React.useState(Date.now());
  const formRef = useRef(null);
  const handleFileChangeMultiple = (e) => {
    const files = e.target.files;
    const filesArray = Array.from(files).map((file) => file);
    setSelectedFiles(filesArray);
  };
  const submit = async (e) => {
    e.preventDefault();

    if (!selectedFiles.length) {
      toast.error("No files selected", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
      return;
    }

    const formData = new FormData(formRef.current);
    setUploading(true);
    try {
      let res = await fetch(
        `${constants.url.API_PREFIX}chatbot/${urlChatID()}/files/upload`,
        {
          method: "POST", // headers: { 'Content-Type': 'multipart/form-data' },
          body: formData,
        },
      );
      let json = await res.json();
      if (json.error) {
        toast.error(json.error, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      } else if (json.message) {
        toast.success(json.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
        setFileInputID(Date.now);
      }
    } catch (e) {
      toast.error("Upload error", {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
      });
    }
    setUploading(false);
    EventBus.getInstance().dispatch("chatbot.sources.files.upload_finished");
    queryClient.invalidateQueries(queryKeyChatbotSummary);
  };

  return (
    <div>
      <div className="bg-slate-50 p-4 rounded-lg">
        <form ref={formRef} encType="multipart/form-data" onSubmit={submit}>
          <Fileinput
            className="bg-white border-2"
            id={fileInputID}
            name="files"
            multiple
            selectedFiles={selectedFiles}
            onChange={handleFileChangeMultiple}
            placeholder={t("knowledge_base.files.placeholder")}
            label={t("browse")}
          />

          <div className="mt-6 flex justify-between">
            <div className="opacity-80">
              <b>{t("knowledge_base.files.supported_formats")}:</b>
              <table className="mt-1">
                <tbody>
                  <tr>
                    <td>Word</td>
                    <td>doc, docx</td>
                  </tr>
                  <tr>
                    <td className="pr-8">Text files, CSV table</td>
                    <td>txt, csv</td>
                  </tr>
                  <tr>
                    <td>HTML, Markdown</td>
                    <td>html, md</td>
                  </tr>
                  <tr>
                    <td>PDF</td>
                    <td>pdf</td>
                  </tr>
                  <tr>
                    <td>PowerPoint</td>
                    <td>ppt, pptx</td>
                  </tr>

                  <tr>
                    <td>EverNote files</td>
                    <td>enex</td>
                  </tr>
                  <tr>
                    <td>e-book file format</td>
                    <td>epub</td>
                  </tr>
                  <tr>
                    <td>Email file</td>
                    <td>eml</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <button
                type="submit"
                className="btn btn inline-flex justify-center btn-primary btn"
              >
                <span className="flex items-center">
                  <span>{uploading ? <LoadingSpinner /> : t("knowledge_base.files.upload")}</span>
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <ListFiles />
    </div>
  );
};

export default ChatBotSourcesFiles;
